import React, { useEffect, useState } from 'react';
import client from '../api/client';
import ShareModal from '../components/ShareModal';
import '../App.css';

function Landing() {
  const [surveys, setSurveys] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [startingSurveyId, setStartingSurveyId] = useState(null);
  const [shareSurvey, setShareSurvey] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    setError('');

    client
      .get('/chatbot/surveys')
      .then((res) => {
        setSurveys(res.data?.data?.surveys || []);
      })
      .catch(() => {
        setError('Impossible de charger les sondages.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const startChat = async (surveyId) => {
    setStartingSurveyId(surveyId);
    setError('');

    try {
      const response = await client.post('/chatbot/session/start', {
        survey_id: surveyId,
      });

      const chatPath = response.data?.data?.chat_path;
      if (chatPath) {
        window.location.href = chatPath;
        return;
      }

      setError('\u00c9chec de la cr\u00e9ation de session.');
    } catch (e) {
      setError('Impossible de cr\u00e9er la session. Veuillez r\u00e9essayer.');
    } finally {
      setStartingSurveyId(null);
    }
  };

  return (
    <div className="landing">
      <header className="landing__hero">
        <img
          src={`${process.env.PUBLIC_URL}/IMMERSION CONSULTING GROUP NOIR.png`}
          alt="Immersion Consulting Group"
          className="page-logo"
        />
        <div className="landing__hero-content">
          <span className="landing__badge">En ligne</span>
          <h1 className="landing__title">
            Partagez Votre <em>Avis</em>
          </h1>
          <p className="landing__subtitle">
            Choisissez un sondage ci-dessous et lancez la conversation.
            Vos réponses sont confidentielles et contribuent à améliorer nos services.
          </p>
        </div>
      </header>

      <div className="landing__body">
        <div className="landing__section-header">
          <h2 className="landing__section-title">Sondages en cours</h2>
          <div className="landing__section-line" />
        </div>

        {isLoading && (
          <div className="landing__grid">
            {[0, 1].map((i) => (
              <div className="skeleton-card" key={i}>
                <div className="skeleton-line skeleton-line--title" />
                <div className="skeleton-line skeleton-line--text" />
                <div className="skeleton-line skeleton-line--short" />
              </div>
            ))}
          </div>
        )}

        {error && (
          <p className="landing__status landing__status--error">Impossible de charger les sondages.</p>
        )}

        {!isLoading && !error && surveys.length === 0 && (
          <p className="landing__status landing__status--empty">
            Aucun sondage actif trouvé.
          </p>
        )}

        {!isLoading && surveys.length > 0 && (
          <div className="landing__grid">
            {surveys.map((survey, i) => (
              <article
                className="survey-card"
                key={survey.id}
                style={{ animationDelay: `${0.3 + i * 0.08}s` }}
              >
                <h3 className="survey-card__title">{survey.title}</h3>
                <p className="survey-card__desc">
                  {survey.description || 'Aucune description.'}
                </p>
                <div className="survey-card__footer">
                  <span className="survey-card__meta">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                    Chat interactif
                  </span>
                  <div className="survey-card__actions">
                    <button
                      type="button"
                      className="survey-card__share-btn"
                      onClick={() => setShareSurvey(survey)}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="18" cy="5" r="3" />
                        <circle cx="6" cy="12" r="3" />
                        <circle cx="18" cy="19" r="3" />
                        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      className="btn btn--primary"
                      onClick={() => startChat(survey.id)}
                      disabled={startingSurveyId === survey.id}
                    >
                      {startingSurveyId === survey.id ? (
                        'D\u00e9marrage\u2026'
                      ) : (
                        <>
                          Commencer
                          <span className="btn__arrow">&rarr;</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>

      {shareSurvey && (
        <ShareModal
          surveyTitle={shareSurvey.title}
          shareUrl={`${window.location.origin}/surveys`}
          onClose={() => setShareSurvey(null)}
        />
      )}
    </div>
  );
}

export default Landing;
